import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { Form } from "react-router-dom";
import axios from "../../API/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { debounce } from "lodash";
import {customStyles, wljSelectPortalProps} from "../../selectStyles";
import { findSelectOption, resolveOrgUid, seedSelectOptions } from "../../utility/selectFieldHelpers";
import Flatpickr from 'react-flatpickr';
import { resume } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";
import { Input } from "reactstrap";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";

import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Portal } from "../../components/Portal";


const ProfileAwardUpdate = ({
  showAwardUpdate,
  handleUpdateAwardClose,
  getUserProfile,
  showAwardData,
}) => {
  const { t } = useTranslation();
  useEscapeKeyDown(showAwardUpdate, handleUpdateAwardClose);
  const UserCcv = localStorage.getItem("UserCcv");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
const language = localStorage.getItem("Lang");
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const sessionId = localStorage.getItem("sessionId");
  const [cerName, setCerName] = useState('');
  const [recognition, setRecognition] = useState("");
  const [startDate, setStartDate] = useState("");
  const [description, setDescription] = useState("");
  const [orgType, setOrgType] = useState("");

  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState("");

  const [display, setDisplay] = useState(false);

  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);

  const [orgData, setOrgData] = useState([]);
  const [orgId, setOrgId] = useState(null);
  const getOrgType = () => {
    axios
      .get(`Master/GetOrgTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setOrgData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getOrgType();
  }, []);

  const [valueC, setValueC] = useState(null);
  const [pageC, setPageC] = useState(0);
  const [typeC, setTypeC] = useState("");
  const [isLoadingC, setIsLoadingC] = useState(false);
  const [optionsC, setOptionsC] = useState([]);
  const [totalPagesCom, setTotalPagesCom] = useState(0);

  const logValueC = debounce((typeC) => {
    setTypeC(typeC);
  }, 250);

  const Companies = () => {
    setIsLoadingC(true);
    axios
      .get(
        `Master/GetCompaniesDDL?search=${typeC}&pageNumber=${pageC + 1
        }&pageSize=100&LangKey=${language}&DeviceType=Web`
      )
      .then((response) => {
        const data = response?.data?.responseData?.orgList.map((item) => ({
          value: item.uiDno,
          label: item.name,
        }));
        setPageC((prevPage) => prevPage + 1);
        setIsLoadingC(false);
        setOptionsC((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesCom(response.data.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingC(false);
      });
  };

  const handleOpenC = () => {
    setPageC(1);
  };

  const handleChangeC = (value) => {
    setValueC(value.value);
    setPageC(0);
  };

  const handleInputChangeC = (typed) => {
    logValueC(typed);
    if (!typed) setPageC(0);
  };

  const handleMenuScrollToBottomC = () => {
    if (pageC < totalPagesCom) {
      Companies();
    }
  };
  useEffect(() => {
    if (typeC) {
      Companies();
    }
  }, [typeC]);
  //********Institution DDL Start  ********//
    const [sync, setSync] = useState(false);

  const [valueIns, setValueIns] = useState(null);
  const [pageIns, setPageIns] = useState(0);
  const [typedIns, setTypedIns] = useState("");
  const [optionsIns, setOptionsIns] = useState([]);
  const [totalPagesIns, setTotalPagesIns] = useState(0);
  const logValueIns = debounce((typedIns) => {
    setTypedIns(typedIns);
  }, 250);
  const addOptionsIns = () => {
    axios
      .get(
        `Master/GetInstitutionsDDL?search=${typedIns}&pageNumber=${pageIns + 1
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        const data = response.data.responseData.orgList.map((item) => ({
          value: item.uiDno,
          label: item.name,
        }));
        setPageIns((prevPage) => prevPage + 1);
        setOptionsIns((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesIns(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenIns = () => {
    setPageIns(1);
  };

  const handleChangeIns = (valueIns) => {
    if (valueIns) {
      setValueIns(valueIns.value);
    } else {
      setValueIns(""); // or handle the clear case appropriately
    }

    setPageIns(0);
  };

  const handleInputChangeIns = (typedIns) => {
    logValueIns(typedIns);
    if (!typedIns) setPageIns(0);
  };

  const handleMenuScrollToBottomIns = () => {
    if (pageIns < totalPagesIns) {
      addOptionsIns();
    }
  };

  useEffect(() => {
    if (typedIns) {
      addOptionsIns();
    }
  }, [typedIns]);

  //********General Org DDL Start  ********//
  const [valuegnr, setValuegnr] = useState(null);
  const [pagegnr, setPagegnr] = useState(0);
  const [typedgnr, setTypedgnr] = useState("");
  const [optionsgnr, setOptionsgnr] = useState([]);
  const [totalPagesgnr, setTotalPagesgnr] = useState(0);
  const logValuegnr = debounce((typedgnr) => {
    setTypedgnr(typedgnr);
  }, 250);
  const addOptionsgnr = () => {
    axios
      .get(
        `Master/GetAllOrganizationsDDL?search=${typedgnr}&pageNumber=${pagegnr + 1
        }&pageSize=100&DeviceType=Web&LangKey=${language}`
      )
      .then((response) => {
        const data = response.data.responseData.list.map((item) => ({
          value: item.uiDno,
          label: item.name,
          typeId: item.typeId,
          isOrgVrfd: item.isVerified,
          isOrgRgd: item.isRgstrd,
        }));
        setPagegnr((prevPage) => prevPage + 1);
        setOptionsgnr((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesgnr(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpengnr = () => {
    setPagegnr(1);
  };

  const handleChangegnr = (valuegnr) => {
    if (valuegnr) {
      setValuegnr(valuegnr.value);
      setOrgType(valuegnr.typeId)
    } else {
      setValuegnr(""); // or handle the clear case appropriately
      setOrgType("")
    }

    setPagegnr(0);
  };

  const handleInputChangegnr = (typedgnr) => {
    logValuegnr(typedgnr);
    if (!typedgnr) setPagegnr(0);
  };

  const handleMenuScrollToBottomgnr = () => {
    if (pagegnr < totalPagesgnr) {
      addOptionsgnr();
    }
  };
  useEffect(() => {
    if (typedgnr) {
      addOptionsgnr();
    }
  }, [typedgnr]);
  const [getOrgInsTId, setGenOrgInstId] = useState('')
  const [newOrgType, setnewOrgType] = useState(null);

  const UpdateAward = async () => {
    setDisplay(true);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      name: cerName,
      recognition: recognition,
      issuingOrgType: orgType === '' ? 4 : orgType,
      orgId: valuegnr === null ? JSON.stringify(getOrgInsTId) : valuegnr,
      description: description,
      issueDate: startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"),
      // "locationId": valueLocation === '' ? '' : valueLocation,
      locationId: null,
      cityId: cityId === "" ? "" : cityId,
      userAwardId: showAwardData?.userAwardId,
      langKey: language === "en" ? "" : language,
      isSynced: sync
    };
    if (cerName === '' || cityId === null || startDate === '' || orgType === '') {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
    } else {
      try {
        await axios.put(`UserData/UpdateAwardInfo`, data).then((resData) => {
          // toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          getUserProfile();
          handleUpdateAwardClose();
          // addReset()
        });
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
  };


  // useEffect(() => {
  //   if (showAwardUpdate) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showAwardUpdate]);


  useEffect(() => {
    if (showAwardData) {
      const orgValue =
        showAwardData?.orgUid ?? showAwardData?.orgUId ?? showAwardData?.orgId;
      setCerName(showAwardData?.name);
      setRecognition(showAwardData?.recognition);
      setStartDate(showAwardData.issueDate ? moment(showAwardData.issueDate).toDate() : null);
      setDescription(showAwardData?.description);
      setOrgId(showAwardData?.issuerOrgType);
      setOrgType(showAwardData?.issuerOrgType);
      setCityId(showAwardData?.cityId);
      setCitySearch(showAwardData?.cityName)
      setTypeC(showAwardData?.orgId)
      setValueC(showAwardData?.orgId)
      setValuegnr(orgValue)
      setTypedgnr(showAwardData?.orgName)
      setOrganizationName(showAwardData?.orgName)
      setInsName(showAwardData?.orgName)
      setPagegnr(0)
      if (showAwardData?.orgName && orgValue) {
        setOptionsgnr(seedSelectOptions(orgValue, showAwardData.orgName, {
          typeId: showAwardData.issuerOrgType,
          isOrgVrfd: showAwardData.isOrgVrfd,
          isOrgRgd: showAwardData.isOrgRgd,
        }));
      }
      if (showAwardData?.cityId && showAwardData?.cityName) {
        setCityData(seedSelectOptions(showAwardData.cityId, showAwardData.cityName));
      }
    }
  }, [showAwardData]);

  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };
  const [showTooltip, setShowTooltip] = useState(false);
  const [OrganizationName, setOrganizationName] = useState("");
  const [InsName, setInsName] = useState("");
  const targetRef = useRef(null);
  const toggleTooltip = () => {
    setShowTooltip((prev) => !prev);
  };

  const handleCloseNewOrg = (e) => {
    e?.preventDefault?.();
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setnewOrgType(null);
    setValuegnr(null);
    setOrgType("");
    setFileName("");
  };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };

  const [orgCity, setOrgCity] = useState(null);
  const handleSaveInstitution = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      gnrlOrgName: OrganizationName,
      type: 3,
      cityId: cityId,
      logoImage: fileName,
      locationId: null,
      langKey: language === "en" ? "" : language,
    }

    try {
      const res = await axios.post("/General/AddGeneralOrgByUser", data);
      setGenOrgInstId(res.data.responseData.id);
      setnewOrgType(res.data.responseData.value);
      setInsName(res.data.responseData.value);
      // toast.success(res.data.message);
      setShowTooltip(false);
      setOrganizationName("");
      setOrgCity(null);
      setFileName("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // toast.warning(error.response.data.message);
      } else {
        // toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // //************************Enable Award  ************************//
  // const [status, setStatus] = useState('')
  // const EnableAwards = async (Id) => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: Id,
  //   };
  //   try {
  //     await axios.put(`UserData/EnableAwardInfo`, responseData).then((res) => {
  //       setToastMessage(res.data.message);
  //       setShowToast(true);
  //       // getUserProfile();
  //       setStatus(1)
  //     });
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // //************************Enable Award End  ************************//
  // //************************Disable Award  ************************//
  // const DisableAwards = async (Id) => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: Id,
  //   };
  //   try {
  //     await axios.put(`UserData/DisableAwardInfo`, responseData).then((res) => {
  //       setToastMessage(res.data.message);
  //       setShowToast(true);
  //       // getUserProfile();
  //       setStatus(0)
  //     });
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // //************************Disable Award End  ************************//

  // const [showAwardDelete, setShowAwardDelete] = useState(false);
  // const handleRemoveAwardClose = () => {
  //   setShowAwardDelete(false);
  // };
  // const [AwardId, setAwardId] = useState("");
  // const removeAward = async () => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: AwardId,
  //     // skllId: skillId
  //   };
  //   try {
  //     await axios
  //       .delete(`UserData/DeleteAwardInfo`, { data: responseData })
  //       .then((res) => {
  //         setShowAwardDelete(!showAwardDelete);
  //         // toast.success(res.data.message);
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         getUserProfile();
  //       });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };

  useEffect(() => {
    let scrollY = 0;
    if (showAwardUpdate) {
      // Save current scroll position
      scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY; // store in dataset
      // Lock scrolling
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    } else {
      // Unlock scrolling
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open');
      // Restore scroll position
      const storedY = document.body.dataset.scrollY || "0";
      window.scrollTo(0, parseInt(storedY, 10));
    }
  }, [showAwardUpdate]);
  const modalContentRef = useRef(null);

  return (
    <>
      {showAwardUpdate && (
        <Portal layer="modal">
        <div
          className="modal fade show modal-lg wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" ref={modalContentRef}>
              <div className="setting-header d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-3">{t ("User Profile.Update Award")}</h6>
                  {/* <div className="form-switch form-check-primary ms-2">
                    <Input
                      type="switch"
                      defaultChecked={showAwardData?.status === 1 || status === 1}
                      name="icon-primary"
                      onClick={() => {
                        if (showAwardData?.status === 1 || status === 1) {
                          DisableAwards(showAwardData.userAwardId);
                        } else {
                          EnableAwards(showAwardData.userAwardId);
                        }
                      }}
                      className=""
                    />
                  </div>
                  <DeleteOutlineSharpIcon
                    className="material-symbols-sharp pointer delete-icon"
                    onClick={() => {
                      setShowAwardDelete(!showAwardDelete);
                      setAwardId(showAwardData.userAwardId);
                    }}
                  /> */}
                </div>
                <CloseSharpIcon
                  className="material-symbols-sharp me-3 pointer"
                  onClick={() => {
                    handleUpdateAwardClose();
                    // addReset()
                  }}
                />
              </div>
              <Form>
                <div className="row modal-p settings CreateCompany">
                  <div className="col-md-6 mt-2 ">
                    <label htmlFor="about" className="wlj-edu-field-label">
                       {t ("User Profile.Award Name")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="text"
                      value={cerName}
                      onChange={(e) => setCerName(e.target.value)}
                      invalid={display && cerName === ""}
                    />
                    {display && !cerName ? (
                      <span className="error_msg_lbl">{t ("User Profile.Enter Award Name")} </span>
                    ) : null}
                  </div>
                  <div className="col-md-6 mt-2">
                    <div className="wlj-edu-label-row d-flex align-items-center">
                      <label htmlFor="about" className="mb-0">
                         {t ("User Profile.Organization")}
                        <span className="text-danger ms-2">*</span>
                      </label>
                      {InsName !== "" ? (
                        <a
                          href="#"
                          onClick={handleCloseNewOrg}
                          className="createModal f-14 ms-2"
                        >
                          {t("User Profile.Close")}
                        </a>
                      ) : (
                      <a
                        href="#"
                        ref={targetRef}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTooltip();
                        }}
                        className="createModal f-14 ms-2"
                      >
                        {t("User Profile.Create New")}   
                      </a>
                      )}
                    </div>
                    <Overlay
                      target={targetRef.current}
                      show={showTooltip}
                      placement="bottom"
                      rootClose
                      container={document.querySelector(".modal")}
                      onHide={() => setShowTooltip(false)} // Close when clicking outside
                    >
                      <Popover id="popover-basic">
                        <Popover.Header as="h3" className="Dark-Body-Card-group">{t ("modals.Create Organization")}</Popover.Header>
                        <Popover.Body className="Dark-Body-Card-group">
                          <Form>
                            <div>
                              <label className="mb-1 Text-mb-Create">{t("modals.Organization Name")}</label>
                              <input
                                type="text"
                                value={OrganizationName}
                                onChange={(e) => setOrganizationName(e.target.value)}
                                placeholder= {t ("modals.Enter Organization Name")}
                                className="mb-2 form-control Dark-Input-from-group"
                              />
                            </div>
                            <div>
                              <label className="mb-1 Text-mb-Create">{t ("Manage Companies.City")}</label>
                              <Select
                                defaultValue={cityId}
                                onChange={(selectedOption) =>
                                  setCityId(selectedOption.value)
                                }
                                options={cityData}
                                placeholder= {t ("modals.Search and Select City")}
                                onInputChange={(inputValue) => {
                                  setCitySearch(inputValue);

                                }}
                                invalid={display && cityId === ""}
                                styles={customStyles} {...wljSelectPortalProps}
                              />
                            </div>
                            <div className=" mt-2 mb-2 Text-mb-Create">
                              <label className="mb-1">{t ("User Profile.Institute logo")}</label>
                              <input
                                type="file"
                                id="lastName"
                                // className="form-control Dark-Input-from-group"
                                placeholder=""
                                onChange={handleFileChange}
                              />
                            </div>
                            <div className="d-flex justify-content-end">
                              <button
                                type="button"
                                className="closebtn me-2 ms-3"
                                onClick={() => {
                                  setShowTooltip(false);
                                  setOrganizationName("");
                                }}
                                style={{ width: "50px", height: "30px" }}
                              >
                                {t ("User Profile.Close")} 
                              </button>

                              <button
                                type="button"
                                className="mainBtn"
                                onClick={handleSaveInstitution}
                                style={{ height: "30px !important", padding: '0px 11px' }}
                              >
                                 {t ("Newsfeed.Save")}
                              </button>
                            </div>
                          </Form>
                        </Popover.Body>
                      </Popover>
                    </Overlay>
                    {InsName !== "" ? (
                      <div className="d-flex align-items-center wlj-org-selected-row">
                        <input
                          type="text"
                          value={InsName}
                          placeholder={t("modals.Enter Organization Name")}
                          className="form-control"
                          disabled
                        />
                        <CloseSharpIcon
                          className="material-symbols-sharp pointer"
                          onClick={handleCloseNewOrg}
                          title={t("User Profile.Close")}
                        />
                      </div>
                    ) : (
                    <Select
                      value={findSelectOption(optionsgnr, valuegnr)}
                      options={optionsgnr}
                      onOpen={handleOpengnr}
                      onChange={handleChangegnr}
                      onMenuScrollToBottom={handleMenuScrollToBottomgnr}
                      onInputChange={handleInputChangegnr}
                      styles={customStyles} {...wljSelectPortalProps}
                      isClearable
                      className="iconsDropdown"
                      classNamePrefix="react-select"
                      placeholder= {t ("User Profile.Search and Select Org")}
                      formatOptionLabel={(option) => (
                        <div>
                          {option.label}

                          {option.isOrgVrfd === true ? (
                            <img src={resume.verified} width={15} className="ms-1" />
                          ) : option.isOrgRgd === true ? (
                            <img src={resume.register} width={15} className="ms-1" />
                          ) : (
                            <img src={resume.unregister} width={15} className="ms-1" />
                          )}
                        </div>
                      )}
                    />
                    )}
                    {display && !valuegnr && !getOrgInsTId ? (
                      <span className="error_msg_lbl">
                         {t ("User Profile.Please Select Organization Type")}
                        {" "}
                      </span>
                    ) : null}
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t ("User Profile.Recognition")}
                    </label>
                    <input
                      type="text"
                      value={recognition}
                      onChange={(e) => setRecognition(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                       {t ("User Profile.City")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <Select
                      value={findSelectOption(cityData, cityId)}
                      className="dropdownBorder"
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      placeholder= {t ("modals.Search and Select City")}
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      styles={customStyles} {...wljSelectPortalProps}
                      classNamePrefix="react-select"
                      invalid={display && cityId === ""}
                    />
                    {display && !cityId ? (
                      <span className="error_msg_lbl">{t ("User Profile.Enter City")}</span>
                    ) : null}
                  </div>


                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t ("User Profile.Issue Date")}
                      <span className="text-danger ms-2">*</span>
                    </label>

                    <Flatpickr className='form-control' value={startDate} onChange={date => setStartDate(date[0])} id='dob' options={{
                      maxDate: "today", // Disables future dates
                      appendTo: modalContentRef.current || undefined,
                      onReady: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Call the function to stop scroll on year
                      },
                      onOpen: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Also prevent scroll when the picker opens
                      },
                    }} />
                    {display && !startDate ? (
                      <span className="error_msg_lbl">
                        {t ("User Profile.Please Select Issue Date")}
                        {" "}
                      </span>
                    ) : null}
                  </div>
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t ("User Profile.Description")}
                    </label>
                    <textarea
                      id="about"
                      name="about"
                      rows="4"
                      cols="50"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    // invalid={display && description === ""}
                    ></textarea>
                    {/* {display && !description ? (
                      <span className="error_msg_lbl">Enter Description </span>
                    ) : null} */}
                  </div>

                  <div className="col-md-12 text-end mt-4">
                     <div className="d-flex align-items-center justify-content-end">
                      {UserCcv === "Active" && <>
                        <input
                          type="checkbox"
                          style={{ width: "20px", height: "20px", marginRight: "5px" }}
                          onChange={() => setSync(!sync)}
                          checked={sync}
                        />
                      <label htmlFor="about">
                        {t("User Profile.Sync With Resume")}
                      </label>
                      </>}  
                    <button
                      type="button"
                      className="closebtn me-2 ms-3"
                      onClick={handleUpdateAwardClose}
                      style={{ width: "70px" }}
                    >
                       {t("User Profile.Close")}
                    </button>
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={UpdateAward}
                      style={{ width: "107px" }}
                    >
                      
                       {t("Manage Job.Update")}
                    </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        </Portal>
      )}


      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {/* {showAwardDelete && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  Are You Sure You want to Delete Award?
                </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveAwardClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeAward()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )} */}


    </>


  );
};

export default ProfileAwardUpdate;
